import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    cartDatas: [],
};

const cartDataSlice = createSlice({
    name: "cartDatas",
    initialState,
    reducers: {
        addCartDatas: (state, action) => {
            state.cartDatas = action.payload;
        },
        removeCartDatas: (state) => {
            state.cartDatas = []
        }
    },
});
export const {
    addCartDatas,
    removeCartDatas
} = cartDataSlice.actions;
export default cartDataSlice.reducer;
